module.exports = __webpack_public_path__ + "static/media/9-3.67426311.mp3";